import { Icon } from "@circle-react-shared/Icon";
import { Icon as CompassIcon } from "@circleco/compass/components/Icon";

import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

interface AiSummaryFooterNoteProps {
  children: React.ReactNode;
}

export const AiSummaryFooterNote = ({ children }: AiSummaryFooterNoteProps) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return (
      <div className="flex items-center gap-1">
        <CompassIcon name="sparkle" size="sm" color="tertiary" />
        <Typography.BodyXs color="text-light">{children}</Typography.BodyXs>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <Icon type="16-ai" size={16} className="text-lightest !h-4 !w-4" />
      <Typography.BodyXs color="text-light">{children}</Typography.BodyXs>
    </div>
  );
};
